import { Grid, GridWrap, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RequestData } from '../../../../useRequestData';
interface SourceInstitutionProps {
  requestData: RequestData
}

const SourceInstitution: React.FC<SourceInstitutionProps> = ({ requestData }) => {
  const { t } = useTranslation(); 
  const {
    source_institution: sourceInstitution,
    source_syllabus: sourceSyllabus,
    target_syllabus: targetSyllabus,
  } = requestData;

  return (
    <div className="REQXXI-Paper" >
      <Grid container
        direction="column"
        wrap={'no-wrap' as GridWrap}
        sx={{height: '100%', display: 'flex', justifyContent: 'flex-start' }}
      >
        <Grid item>
          <Grid display={'flex'} flexDirection={'row'} alignItems={'center'} mb={1}>
            <Typography variant="h6" sx={{ fontWeight: 400, color: '#006c5b', fontSize: '20px', marginRight: '10px' }}>
              {t('sourceInstitutionSelected')}
            </Typography>
          </Grid>
          <Grid container
            data-testid={'source-institution'}
            direction="column"
            className='REQXXI-Block-Container'
            gap={'5px'}
          >
            <Typography variant="h6" sx={{ fontWeight: 400, color: 'black', fontSize: '15px', marginRight: '10px' }}>
              {sourceInstitution ? sourceInstitution?.name : ""}
            </Typography>
            <Typography color="#949494" sx={{ fontSize: '12px', paddingLeft: '5px' }}>
                {t('sourceDataVerified')}
              </Typography>
          </Grid>
        </Grid>
        <Grid item
          className='REQXXI-Container-SourceSyllabus'
          mt={3}
        >
          <Typography variant="h6" sx={{ fontWeight: 400, color: '#006c5b', lineHeight: '30px', fontSize: '20px' }} mb={1} mt={2}>
            {t('sourceSyllabusSelected')}
          </Typography>
          
          <Grid container
            id="source-syllabus"
            data-testid={'source-syllabus'}
            direction="column"
            className='REQXXI-Block-Container'
            gap={'5px'}
          >
            <Typography variant="h6" sx={{ fontWeight: 400, color: 'black', fontSize: '15px', marginRight: '10px' }}>
              {sourceSyllabus ? sourceSyllabus?.name : ""}
            </Typography>
            <Typography color="#949494" sx={{ fontSize: '12px', paddingLeft: '5px' }}>
                {t('sourceDataVerified')}
              </Typography>
            
          </Grid>
        </Grid>

        <Grid item
          className='REQXXI-Container-SourceSyllabus'
          mt={3}
        >
          <Typography variant="h6" sx={{ fontWeight: 400, color: '#006c5b', lineHeight: '30px', fontSize: '20px' }} mb={1} mt={2}>
            {t('targetSyllabusSelected')}
          </Typography>
          
          <Grid container
            id="source-syllabus"
            data-testid={'source-syllabus'}
            direction="column"
            className='REQXXI-Block-Container'
            gap={'5px'}
          >
            <Typography variant="h6" sx={{ fontWeight: 400, color: 'black', fontSize: '15px', marginRight: '10px' }}>
              {targetSyllabus ? targetSyllabus?.name : ""}
            </Typography>
            <Typography color="#949494" sx={{ fontSize: '12px', paddingLeft: '5px' }}>
                {t('sourceDataVerified')}
              </Typography>
            
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default SourceInstitution;
